import React, { useState } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const GlobalContext = /*#__PURE__*/React.createContext({});
export const GlobalProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    0: pathBeforeRedirect,
    1: setPathBeforeRedirect
  } = useState(null);
  return ___EmotionJSX(GlobalContext.Provider, {
    value: {
      pathBeforeRedirect,
      setPathBeforeRedirect
    }
  }, children);
};